
import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumetationComponent } from './pages/documentation/documentation.component';
import { MyContractsComponent } from './pages/client/my-contracts/my-contracts.component';
import { MySupportComponent } from './pages/client/my-support/my-support.component';
import { ClientComponent } from './pages/client/client.component';
import { PagesComponent } from './pages/pages.component';
import { ContractComponent } from './pages/client/my-contracts/contract/contract.component';
import { AuthModule } from './services/auth/auth.module';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { MySettingsComponent } from './pages/client/my-settings/my-settings.component';
import { LoginComponent } from './pages/account/login/login.component';
import { AddcontractComponent } from './pages/client/my-contracts/contract/addcontract/addcontract.component';
import { BankAccountsComponent } from './pages/client/my-settings/bank-accounts/bank-accounts.component';
import { ResetPasswordComponent } from './pages/account/reset-password/reset-password.component';
import { ChangepwdComponent } from './pages/account/changepwd/changepwd.component';
import { UpdateRegistrationComponent } from './pages/client/my-contracts/contract/update-registration/update-registration.component';
import { ClientRegisterComponent } from './pages/account/client-register/client-register.component';
import { VendorComponent } from './pages/vendor/vendor.component';
import { PreChatComponent } from './pages/account/pre-chat/pre-chat.component';
import { PostedinvoicesComponent } from './pages/client/my-contracts/postedinvoices/postedinvoices.component';
import { PastdueinvoicesComponent } from './pages/client/my-contracts/pastdueinvoices/pastdueinvoices.component';
import { MySettingsVComponent } from './pages/vendor/my-settings-v/my-settings-v.component';
import { MyProfileVComponent } from './pages/vendor/my-settings-v/my-profile-v/my-profile-v.component';
import { ChangePasswordVComponent } from './pages/vendor/my-settings-v/change-password-v/change-password-v.component';
import { ManageUsersVComponent } from './pages/vendor/my-settings-v/manage-users-v/manage-users-v.component';
import { MyVendorComponent } from './pages/vendor/my-vendor/my-vendor.component';
import { VendorHomeComponent } from './pages/vendor/my-vendor/vendor-home/vendor-home.component';
import { PurchaseOrderViewComponent } from './pages/vendor/my-vendor/purchase-order-view/purchase-order-view.component';
import { InvoicesViewComponent } from './pages/vendor/my-vendor/invoices-view/invoices-view.component';
import { PaymentsViewComponent } from './pages/vendor/my-vendor/payments-view/payments-view.component';
import { BankAccountVComponent } from './pages/vendor/my-settings-v/bank-account-v/bank-account-v.component';
import { RemitToComponent } from './pages/vendor/my-settings-v/remit-to/remit-to.component';
import { VendorRegisterComponent } from './pages/account/vendor-register/vendor-register.component';
import { VendorSupportComponent } from './pages/vendor/my-vendor/vendor-support/vendor-support.component';
import { SearchContractsComponent } from './pages/client/my-contracts/search-contracts/search-contracts.component';
import { MarketPlaceComponent } from './pages/client/market-place/market-place.component';
import { ForgotPasswordComponent } from './pages/account/forgot-password/forgot-password.component';
import { TaxFormsComponent } from './pages/vendor/my-settings-v/tax-forms/tax-forms.component';
import { CoverageSearchComponent } from './pages/vendor/my-vendor/coverage-search/coverage-search.component';
import { VendorSetupComponent } from './pages/vendor-setup/vendor-setup.component';
import { NewVendorComponent } from './pages/vendor-setup/new-vendor/new-vendor.component';
import { DomesticVendorFormComponent } from './pages/vendor-setup/domestic-vendor-form/domestic-vendor-form.component';
import { InternationalVendorFormComponent } from './pages/vendor-setup/international-vendor-form/international-vendor-form.component';
import { W9FormComponent } from './pages/vendor/my-settings-v/tax-forms/w9-form/w9-form.component';
import { Forms1099Component } from './pages/vendor/my-settings-v/tax-forms/1099-forms/1099-forms.component';
import { CompanyComponent } from './pages/vendor/my-settings-v/company/company.component';
import { EnvironmentComponent } from './pages/environment/environment.component';
import { Co2OffsetComponent } from './pages/client/co2-offset/co2-offset.component';
import { MyjssiBundleComponent } from './pages/myjssi-bundle/myjssi-bundle.component';
import { UniversalloginComponent } from './pages/account/login/universallogin/universallogin.component';
import { TransientComponent } from './pages/account/transient/transient.component';
import { MarketingComponent } from './pages/client/marketing/marketing.component';
import { MarketingInfoComponent } from './pages/marketing-info/marketing-info.component';
import { AdvisoryservicesComponent } from './pages/advisoryservices/advisoryservices.component';
const routes: Routes = [
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  {
    path: 'pages', component: PagesComponent, children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },

      {
        path: 'alliance',
        loadChildren: './pages/alliance/alliance.module#AllianceModule'
      },
      {
        path: 'myjssi-bundle', component: MyjssiBundleComponent

      },
      {
        path: 'advisoryservices', component: AdvisoryservicesComponent

      },
      { path: 'marketing', component: MarketingInfoComponent},
      {
        path: 'universal-login', component: UniversalloginComponent

      },

      { path: 'vendor-setup', component: VendorSetupComponent, children: [
        { path: '', redirectTo: 'new-vendor',  pathMatch: 'full'},
        { path: 'new-vendor', component: NewVendorComponent },
        { path: 'domestic-vendor-form', component: DomesticVendorFormComponent },
        { path: 'international-vendor-form', component: InternationalVendorFormComponent }
    ]},
      {
        path: 'client', component: ClientComponent, canActivate: [AuthGuardService], data: { expectedUserTypes: ['CAM', 'AD'] }, children: [

          { path: '', redirectTo: 'my-contracts', pathMatch: 'full' },
          { path: 'co2offset', component: Co2OffsetComponent},

          {
            // tslint:disable-next-line:max-line-length
            path: 'my-support', component: MySupportComponent, canActivate: [AuthGuardService], data: { expectedUserTypes: ['CAM'] }, children: [
              { path: '', redirectTo: 'ask-question', pathMatch: 'full' },
              {
                path: 'ask-question',
                loadChildren: './pages/client/my-support/ask-question/ask-question.module#AskQuestionModule'
              },
              {
                path: 'jssi-team',
                loadChildren: './pages/client/my-support/your-jssi-team/your-jssi-team.module#YourJssiTeamModule'
              },
              {
                path: 'faq',
                loadChildren: './pages/client/my-support/faq/faq.module#FaqModule'
              },
              {
                path: 'help',
                loadChildren: './pages/client/my-support/help/help.module#HelpModule'
              }
            ]
          },
          {
            path: 'postedinvoices', component: PostedinvoicesComponent
          },
          {
            path: 'pastdueinvoices', component: PastdueinvoicesComponent
          },

          {
            // tslint:disable-next-line:max-line-length
            path: 'searchcontracts', component: SearchContractsComponent, canActivate: [AuthGuardService], data: { expectedUserTypes: ['AD'] },
          },
          {
            path: 'my-contracts', component: MyContractsComponent, children: [
              {
                path: 'addcontract', component: AddcontractComponent
              },
              {
                path: 'contract/:id', component: ContractComponent,
                //  runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                //  resolve: {contract: ContractResolverService},
                children: [
                  {
                    path: 'flight-hours',
                    loadChildren: './pages/client/my-contracts/contract/flight-hours/flight-hours.module#FlightHoursModule'
                  },
                  {
                    path: 'update-registration', component: UpdateRegistrationComponent
                    // loadChildren: './pages/client/my-contracts/contract/update-registration/flight-hours.module#FlightHoursModule'
                  },
                  {
                    path: 'contacts',
                    loadChildren: './pages/client/my-contracts/contract/contacts/contacts.module#ContactsModule'
                  },
                  {
                    path: 'support',  canActivate: [AuthGuardService], data: { expectedUserTypes: ['CAM']},
                    loadChildren: './pages/client/my-contracts/contract/support/support.module#SupportModule'
                  },
                  {
                    path: 'overview',
                    loadChildren: './pages/client/my-contracts/contract/overview/overview.module#OverviewModule'
                  },
                  {
                    path: 'financials',
                    loadChildren: './pages/client/my-contracts/contract/financial/financial.module#FinancialModule'
                  }
                ]
              }
            ]
          },
          {
            // tslint:disable-next-line:max-line-length
            path: 'my-settings', component: MySettingsComponent, canActivate: [AuthGuardService], data: { expectedUserTypes: ['CAM'] }, children: [
              {
                path: 'change-password',
                loadChildren: './pages/client/my-settings/change-password/change-password.module#ChangePasswordModule'
              },
              {
                path: 'credit-cards',
                loadChildren: './pages/client/my-settings/credit-cards/credit-cards.module#CreditCardsModule'
              },
              {
                path: 'bank-accounts',
                loadChildren: './pages/client/my-settings/bank-accounts/bank-accounts.module#BankAccountModule'
              },
              {
                path: 'manage-users',
                loadChildren: './pages/client/my-settings/manage-users/manage-users.module#ManageUsersModule'
              },
              {
                path: 'my-profile',
                loadChildren: './pages/client/my-settings/my-profile/my-profile.module#MyProfileModule'
              }
            ]
          }
        ]
      },
      {
        path: 'vendor', component: VendorComponent, canActivate: [AuthGuardService], data: { expectedUserTypes: ['VAM'] }, children: [
          { path: '', redirectTo: 'myvendor/home', pathMatch: 'full' },
          {
            path: 'myvendor', component: MyVendorComponent, children: [
              { path: '', redirectTo: 'home', pathMatch: 'full' },
              {
                path: 'home', component: VendorHomeComponent
              },
              {
                path: 'purchaseorder', component: PurchaseOrderViewComponent
              },
              {
                path: 'invoices', component: InvoicesViewComponent
              },
              {
                path: 'payments', component: PaymentsViewComponent
              },
              {
                path: 'coveragesearch', component: CoverageSearchComponent
              },
              {
                path: 'vendorcontacts',
                loadChildren: './pages/vendor/my-vendor/vendor-contact/vendor-contact.module#VendorContactModule'
              },
              {
                path: 'support', component: VendorSupportComponent
              }


            ]
          },
          {

            path: 'mysettings', component: MySettingsVComponent, children: [
              {
                path: 'myprofile', component: MyProfileVComponent
              },
              {
                path: 'changepassword', component: ChangePasswordVComponent
              }
              ,
              {
                path: 'manageusers',
                loadChildren: './pages/vendor/my-settings-v/manage-users-v/manage-users-v.module#ManageUsersVModule'
              },
              {
                path: 'company', component: CompanyComponent
              },
              {
                path: 'bankAccounts', component: BankAccountVComponent
              },
              {
                path: 'remit-to', component: RemitToComponent
              },
              {
                path: 'taxforms', component: TaxFormsComponent, children: [
                  {
                    path: 'w9', component: W9FormComponent
                  },
                  {
                    path: '1099', component: Forms1099Component
                  }
                ]
              }
            ]
          },
        ]
      },

      {
        path: 'login', component: LoginComponent
      },
      {
        path: 'reset-password', component: ResetPasswordComponent
      },
      {
        path: 'changepwd', component: ChangepwdComponent
      },
      {
        path: 'client-register', component: ClientRegisterComponent
      },
      {
        path: 'pre-chat', component: PreChatComponent
      },
      {
        path: 'vendor-register', component: VendorRegisterComponent
      },
      {
        path: 'forgot-password', component: ForgotPasswordComponent
      },
      {
        path: 'Environment', component: EnvironmentComponent
      },
      {
        path: 'transient', component: LoginComponent
      },
      {
        path: 'ConfirmEmail', component: LoginComponent
      }
    ]
  },
  {
    path: 'documentation', component: DocumetationComponent, canActivate: [AuthGuardService],
    data: { expectedUserTypes: ['AD'] }, children: [
      { path: '', redirectTo: 'colors', pathMatch: 'full' },
      {
        path: 'colors',
        loadChildren: './pages/documentation/color/color.module#ColorModule'
      },
      {
        path: 'accordion',
        loadChildren: './pages/documentation/accordion/accordion.module#AccordionModule'
      },
      {
        path: 'badgesandstatuses',
        loadChildren: './pages/documentation/badges-status/badges-status.module#BadgesStatusModule'
      },
      {
        path: 'buttonsLinks',
        loadChildren: './pages/documentation/buttons-links/buttons-links.module#ButtonsLinksModule'
      },
      {
        path: 'cards',
        loadChildren: './pages/documentation/cards/cards.module#CardsModule'
      },
      {
        path: 'charts',
        loadChildren: './pages/documentation/charts/charts.module#ChartsModule'
      },
      {
        path: 'forms',
        loadChildren: './pages/documentation/forms-fields/forms-fields.module#FormsFieldsModule'
      },
      {
        path: 'grids',
        loadChildren: './pages/documentation/grid/grid.module#GridModule'
      },
      {
        path: 'icons',
        loadChildren: './pages/documentation/iconography/iconography.module#IconographyModule'
      },
      {
        path: 'modals',
        loadChildren: './pages/documentation/modals/modals.module#ModalsModule'
      },
      {
        path: 'navigation',
        loadChildren: './pages/documentation/navigation/navigation.module#NavigationModule'
      },
      {
        path: 'notifications',
        loadChildren: './pages/documentation/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'tables',
        loadChildren: './pages/documentation/tables/tables.module#TablesModule'
      },
      {
        path: 'tabs',
        loadChildren: './pages/documentation/tabs/tabs.module#TabsModule'
      },
      {
        path: 'typography',
        loadChildren: './pages/documentation/typography/typography.module#TypographyModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), AuthModule],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts